var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLayoutGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layout-grid-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M1.75 7H12.25M7 1.75V12.25M4.55 1.75H9.45C10.4301 1.75 10.9201 1.75 11.2945 1.94074C11.6238 2.10852 11.8915 2.37623 12.0593 2.70552C12.25 3.07986 12.25 3.56991 12.25 4.55V9.45C12.25 10.4301 12.25 10.9201 12.0593 11.2945C11.8915 11.6238 11.6238 11.8915 11.2945 12.0593C10.9201 12.25 10.4301 12.25 9.45 12.25H4.55C3.56991 12.25 3.07986 12.25 2.70552 12.0593C2.37623 11.8915 2.10852 11.6238 1.94074 11.2945C1.75 10.9201 1.75 10.4301 1.75 9.45V4.55C1.75 3.56991 1.75 3.07986 1.94074 2.70552C2.10852 2.37623 2.37623 2.10852 2.70552 1.94074C3.07986 1.75 3.56991 1.75 4.55 1.75Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayoutGrid);
export default __webpack_public_path__ + "static/media/layout-grid.0220303ccb97ff93b5475993bd33cfd6.svg";
export { ForwardRef as ReactComponent };